// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1lhSh","select":"Header_select__2PJy-","clinic":"Header_clinic__prGvN"};